<template>
  <div>
    <div v-if="!isNewCollectionEnabled" class="create-collection-action">
      <Button @click.prevent.stop="isNewCollectionEnabled = true" data-testid="collections-modal-create-item-btn" type="ghost" variant="black"
        >Create new collection</Button
      >
    </div>
    <BoxWrapper v-if="isNewCollectionEnabled">
      <div class="add-new-collection">
        <FormKit
          ref="formField"
          :errors="[serverError]"
          validation="required"
          data-testid="collections-modal-create-item-input"
          validation-visibility="dirty"
          :validation-messages="{
            required: 'Name cannot be empty',
          }"
          type="text"
          v-model="newCollectionName"
          placeholder="Type a descriptive collection name"
          @change="serverError = ''"
          @keyup.enter="onNewCollectionSave"
        />
        <Button type="solid" variant="blue" data-testid="collections-modal-create-item-submit" @click.prevent.stop="onNewCollectionSave">Add collection</Button>
      </div>
    </BoxWrapper>
    <HorizontalDivider v-if="!isNewCollectionEnabled" />
  </div>
</template>

<script setup lang="ts">
import { Button, HorizontalDivider, BoxWrapper } from '@/storybook';
import { ref, Ref } from 'vue';
import { useCollectionsStore } from '@/store/useCollectionsStore';

const props = defineProps<{ itemId: string; showInput?: boolean }>();

const collectionsStore = useCollectionsStore();

const isNewCollectionEnabled = ref(props.showInput || false);
const newCollectionName = ref('');

const serverError: Ref<string> = ref('');

const onNewCollectionSave = () => {
  collectionsStore
    .create(newCollectionName.value, props.itemId)
    .then(() => {
      isNewCollectionEnabled.value = false;

      newCollectionName.value = '';
      serverError.value = '';
    })
    .catch(e => {
      if (e.errors) {
        // Set the server error message
        serverError.value = e.errors[0].detail;
      }
    });
};
</script>

<style scoped>
.create-collection-action {
  @apply flex justify-end;
}
.add-new-collection {
  @apply flex gap-3 justify-between items-start;
}
:host .add-new-collection :deep(.formkit-outer) {
  @apply w-full;
}
</style>
